import { FC } from 'react';
import { Chip as MuiChip, ChipProps as MuiChipProps, styled } from '@mui/material';
import DeleteIcon from '../../../../icons/svg/close.svg?react';
import { themeConfig } from '../../../../theme/themeConfig';

const StyledChip = styled(MuiChip, {
  shouldForwardProp: (prop) => prop !== 'color' && prop !== 'filled'
})<MuiChipProps & { filled?: boolean }>(({ theme, color, filled }) => {
  const mainColor =
    color && color != 'default' ? theme.palette[color].main : theme.palette.heaven.main;
  const darkColor =
    color && color != 'default' ? theme.palette[color].dark : theme.palette.heaven.dark;
  const lightColor =
    color && color != 'default' ? theme.palette[color].light : theme.palette.heaven.light;

  return {
    textTransform: 'uppercase',
    fontSize: '0.75rem',
    fontWeight: 'normal',
    color: mainColor,
    backgroundColor: filled ? themeConfig.colors.heaven[200] : 'white',
    borderRadius: '4px',
    border: filled ? 'none' : `1.5px solid ${lightColor}`,
    '.MuiChip-deleteIcon': {
      height: '1.4rem',
      width: '1.4rem',
      marginLeft: '-12px',
      color: mainColor,
      '&:hover': { color: darkColor }
    },
    '.MuiChip-label': {
      paddingLeft: '12px',
      paddingRight: '12px'
    },
    '.MuiChip-icon': {
      color: 'white',
      marginRight: '-8px',
      marginLeft: '8px'
    },
    '&.Mui-disabled': {
      opacity: 0.3,
      '.MuiChip-deleteIcon': {
        color: 'white'
      },
      '.MuiChip-icon': {
        color: 'white'
      }
    },
    '&.MuiChip-outlined': {
      backgroundColor: 'white',
      color: mainColor,
      borderWidth: '2px',
      borderStyle: 'solid',
      borderColor: mainColor,
      '.MuiChip-deleteIcon': {
        color: mainColor
      },
      '.MuiChip-icon': {
        color: mainColor
      }
    }
  };
});

export type ChipProps = MuiChipProps & { filled?: boolean };

export const Chip: FC<ChipProps> = (props) => {
  const { disabled, filled, ...otherProps } = props;

  return (
    <StyledChip
      size="small"
      deleteIcon={<DeleteIcon />}
      disabled={disabled}
      filled={filled}
      {...otherProps}
    />
  );
};
